import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/portal/frm_libro_reclamacion'
const authorization = 'Authorization'
const tipoToken = 'Bearer'

const service = {
  findAll(params) {
    const query = `?estadoReclamo=${params.estadoReclamo}&tipo=${params.tipo}&limit=${params.limit}&page=${params.page}&query=${params.query}&sortBy=${params.sortBy}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  updateStatus(model) {
    const formData = new FormData()
    formData.append('idLibroReclamacion', model.idLibroReclamacion)
    formData.append('observacionAtencion', model.observacionAtencion)
    if (model.archivo !== null) formData.append('archivo', model.archivo)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .put(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
